/**
 * Advanced async (cancellable/abortable) `setTimeout` helper
 */
export default function wait(delay) {
    return (val) => {
        let timer;
        let abort;

        const p = new Promise(function(resolve, reject) {
            abort = reject;
            timer = setTimeout(() => resolve(val), delay);
        });

        p.cancel = () => clearTimeout(timer);
        p.abort = reason => p.cancel() || abort(reason);

        return p;
    };
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/wait.js